module.exports = __webpack_public_path__ + "static/img/bottonMy.0d870ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/bottonMy.png
// module id = 4/Dp
// module chunks = 0